import { NorthVancouverHero } from './components/NorthVancouverHero';
import { ZoningRegulations } from './components/ZoningRegulations';
import { DistrictVsCity } from './components/DistrictVsCity';
import { LicensingFramework } from './components/LicensingFramework';
import { ComplianceRequirements } from './components/ComplianceRequirements';
import { NorthVancouverCTA } from './components/NorthVancouverCTA';
import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';

export default function NorthVancouverSTRPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <NorthVancouverHero />
        <ZoningRegulations />
        <DistrictVsCity />
        <LicensingFramework />
        <ComplianceRequirements />
        <NorthVancouverCTA />
      </main>
      <Footer />
    </div>
  );
}
